import { InstrumentType, InstrumentDefinition, TuningDefinition } from '../types';

export const GUITAR_STANDARD_E_TUNING: TuningDefinition = {
  id: 'guitar-standard-e',
  label: 'Standard E (Guitar)',
  pitches: [
    { note: 'E', octave: 4 },
    { note: 'B', octave: 3 },
    { note: 'G', octave: 3 },
    { note: 'D', octave: 3 },
    { note: 'A', octave: 2 },
    { note: 'E', octave: 2 },
  ],
};

export const GUITAR_DROP_D_TUNING: TuningDefinition = {
  id: 'guitar-drop-d',
  label: 'Drop D (Guitar)',
  pitches: [
    { note: 'E', octave: 4 },
    { note: 'B', octave: 3 },
    { note: 'G', octave: 3 },
    { note: 'D', octave: 3 },
    { note: 'A', octave: 2 },
    { note: 'D', octave: 2 },
  ],
};

export const GUITAR_DEFINITION: InstrumentDefinition = {
  type: InstrumentType.Guitar,
  name: 'Guitar',
  defaultNumFrets: 22,
  defaultTunings: [GUITAR_STANDARD_E_TUNING, GUITAR_DROP_D_TUNING],
};
